/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense } from 'react';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import routes from '../../Components/Routes/Routes';
import Header from '../../Components/Commons/Header/Header';
import Footer from '../../Components/Commons/Footer/index';

function App() {
  return (
    <Router>
      <Header />
      <Suspense fallback={<div> </div>}>
        <Switch>
          {routes.map((route, key) => (
            <Route {...route} key={`page-${key + 1}`} />
          ))}
        </Switch>
      </Suspense>
      <Footer />
    </Router>
  );
}

export default App;
